module.exports = __webpack_public_path__ + "images/thumb-eb73b4575cb333d1c748417af027293a.jpg";